<script>
import { authComputed } from '@state/helpers'
import { ADMIN_ROLE } from '@utils/constant'
import { mergeArray } from '@utils/common'
import formatDate from '@utils/format-date'
import formatTime from '@utils/format-time'
import TableDetail from '@components/table-detail'

export default {
  components: {
    TableDetail: TableDetail,
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    fields: {
      type: Array,
      required: true,
      default: () => [],
    },
    tableName: {
      type: String,
      default: '',
    },
    htmlFields: {
      type: Array,
      default: () => [],
    },
    striped: {
      type: Boolean,
      required: false,
      default: false,
    },
    bordered: {
      type: Boolean,
      required: false,
    },
    currentPage: {
      type: Number,
      required: true,
      default: 1,
    },
    totalRows: {
      type: Number,
      required: true,
      default: 1,
    },
    perPage: {
      type: Number,
      required: true,
      default: 10,
    },
    pagingCounter: {
      type: Number,
      required: true,
      default: 1,
    },
    totalPage: {
      type: Number,
      required: true,
      default: 1,
    },
  },
  data() {
    return {
      ADMIN_ROLE: ADMIN_ROLE,
      active: 0,
      reportData: [],
      Report: [],
      searchInput: [],
      filterItems: [],
      isSearch: false,
      previousRow: '',
    }
  },
  computed: {
    ...authComputed,
  },
  methods: {
    onTextChange() {
      this.filterItems = []
      var searchStatus = false
      for (var key in this.searchInput) {
        if (
          this.searchInput[key] &&
          this.searchInput[key] !== null &&
          this.searchInput[key].length > 0 &&
          this.searchInput[key] !== ''
        ) {
          searchStatus = true
        }
        var filterItem = this.items.filter((item) => {
          return (
            item[key]
              .toLowerCase()
              .indexOf(this.searchInput[key].toLowerCase()) > -1
          )
        })
        if (filterItem.length > 0) {
          this.filterItems = mergeArray(this.filterItems, filterItem)
        }
      }

      this.isSearch = searchStatus

      if (!this.isSearch) {
        this.resetFilter()
      }
    },
    formatDates(date) {
      return formatDate(date)
    },
    getTime(time) {
      return formatTime(time)
    },
    resetFilter() {
      this.searchInput = []
      this.filterItems = []
    },

    expandTable(row) {
      if (row.detailsShowing === false) {
        if (this.previousRow !== '') {
          this.previousRow.toggleDetails()
        }
        this.previousRow = row
      }
      row.toggleDetails()
    },

    // pagination link generate
    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`
    },
  },
}
</script>

<template>
  <div>
    <b-table
      id="datatable"
      :fields="fields"
      :items="isSearch ? filterItems : items"
      :bordered="bordered"
      :striped="striped"
      responsive="md"
    >
      <!-- A custom formatted header cell for field 'name' -->
      <template v-slot:head()="scope">
        <div
          v-if="scope.field.label === 'College' && role === ADMIN_ROLE"
          class="text-nowrap capital"
          >{{ scope.field.label }}</div
        >
        <div v-else class="text-nowrap capital">{{ scope.field.label }}</div>
      </template>

      <template v-slot:cell(status)="data">
        <b-badge v-if="data.item.status" variant="success">Done</b-badge>
        <b-badge v-else variant="danger">Pending</b-badge>
      </template>
      <template v-slot:cell(loginStatus)="data">
        <b-badge v-if="data.item.loginStatus" variant="success">Active</b-badge>
        <b-badge v-else variant="danger">Inactive</b-badge>
      </template>
      <template v-slot:cell(date)="data">{{
        formatDates(data.item.date)
      }}</template>
      <template v-slot:cell(createdAt)="data">{{
        formatDates(data.item.createdAt)
      }}</template>
      <template v-slot:cell(feedback)="data">{{ data.item.message }}</template>
      <template v-slot:cell(time)="data">{{
        getTime(data.item.time)
      }}</template>
      <template v-slot:cell(course)="data">{{
        data.item.course ? data.item.course.name : ''
      }}</template>
      <template v-slot:cell(rating)="data">
        <star-rating
          v-if="data.item.rating"
          :rating="parseFloat(data.item.rating)"
          read-only
          :round-start-rating="false"
          :star-size="12"
        >
        </star-rating>
      </template>
      <template v-slot:cell(avg_rating)="data">
        <star-rating
          v-if="data.item.avg_rating"
          :rating="parseFloat(data.item.avg_rating)"
          read-only
          :round-start-rating="false"
          :star-size="12"
        >
        </star-rating>
      </template>
      <template v-slot:cell(collegeId)="data">
        <p>{{ data.item.college.site_name }}</p>
      </template>
      <template v-slot:cell(tags)="data">
        <div v-for="(item1, index1) in data.item.tags" :key="`list${index1}`">
          <p v-if="index1 + 1 === data.item.tags.length">{{ item1 }}</p>
          <p v-else>{{ item1 }},</p>
        </div>
      </template>
      <!--  Toggle detail view of table row  start  -->
      <template v-slot:cell(question)="row">
        <b-button
          size="sm"
          class="mr-2"
          variant="link"
          @click.stop="row.toggleDetails"
          >{{ row.detailsShowing ? 'Hide' : 'Show' }} Details</b-button
        >
      </template>
      <template v-slot:row-details="row">
        <TableDetail :data="row" :table-name="'QUESTION'"></TableDetail>
      </template>
    </b-table>
    <b-row align-h="between">
      <b-col cols="4">
        <label>
          Showing {{ pagingCounter }} to
          {{ pagingCounter + (items.length - 1) }} of {{ totalRows }} entries
        </label>
      </b-col>
      <b-col v-if="currentPage" cols="8">
        <b-pagination-nav
          class="pullRight"
          :link-gen="linkGen"
          :number-of-pages="totalPage"
          use-router
        ></b-pagination-nav>
      </b-col>
      <!-- <b-button v-if="downloadbtn" @click="pdf(all)">Download</b-button> -->
    </b-row>
  </div>
</template>
<style scoped>
.pullRight {
  float: right;
}
.capital {
  text-transform: uppercase;
}
</style>
